<template>
  <div class="page-shop-manage-edit">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">澳門門店</div>
      <div class="breadcrumb-item">店櫃管理</div>
    </div>

    <div class="pg-block">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <div class="pg-form-wrap">
        <Row>
          <Col span="11">
            <Form :label-width="300">
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>店櫃序碼</span>
                </div>
                <Input v-model="form.cainiao_match"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>店櫃名稱</span>
                </div>
                <Input v-model="form.ReceivingName"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>店櫃名稱（簡稱）</span>
                </div>
                <Input v-model="form.ReceivingNameShort"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>店櫃區域</span>
                </div>
                <Select placeholder="請選擇區域" v-model="form.macauDistrict">
                  <Option value="澳门半岛花地玛堂区">澳门半岛花地玛堂区</Option>
                  <Option value="澳门半岛花王堂区">澳门半岛花王堂区</Option>
                  <Option value="澳门半岛望德堂区">澳门半岛望德堂区</Option>
                  <Option value="澳门半岛大堂区">澳门半岛大堂区</Option>
                  <Option value="澳门半岛风顺堂区">澳门半岛风顺堂区</Option>
                  <Option value="离岛嘉模堂区">离岛嘉模堂区</Option>
                  <Option value="离岛路氹填海区">离岛路氹填海区</Option>
                  <Option value="离岛圣方济各堂区">离岛圣方济各堂区</Option>
                  <Option value="其他區">其他区</Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>店櫃地址</span>
                </div>
                <Input v-model="form.ReceivingAddress"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>經度</span>
                </div>
                <Input v-model="form.X"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>緯度</span>
                </div>
                <Input v-model="form.Y"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>自提點類型</span>
                </div>
                <Select placeholder="請選擇" v-model="form.Type">
                  <Option :value="1">門店</Option>
                  <Option :value="2">智能櫃</Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>營業開始時間</span>
                </div>
                <!-- <Input v-model="form.start_time"></Input> -->
                <TimePicker
                  class="no-suffix"
                  type="time"
                  :clearable="false"
                  placeholder="開始日期"
                  v-model="form.start_time"
                  value-format="hh:mm:ss"
                  style="width: 100%"
                  :disabled="form.do_type === 2"
                ></TimePicker>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>店櫃關聯公司</span>
                </div>
                <Select
                  v-model="form.company_id"
                  placeholder="請選擇店櫃關聯公司"
                >
                  <Option
                    :value="item.id"
                    v-for="(item, index) in samecityList"
                    :key="item.id"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>

              <FormItem v-if="this.$store.state.logInfo.type == 1">
                <div slot="label" class="form-label">
                  <!-- <em class="red">* </em> -->
                  <span>門店人員-關聯帳號</span>
                </div>
                <Select v-model="form.admin_id" placeholder="請選擇">
                  <Option
                    :value="item.user_id"
                    v-for="(item, index) in pickAdmin"
                    :key="item.user_id"
                    >{{ item.username }} ({{ item.realname }})
                  </Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>線下(門店/智能櫃)簽收立減N元</span>
                </div>
                <InputNumber
                  :max="10"
                  :min="0"
                  v-model="form.offline_activity"
                />
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>線上APP支付快遞立減N元</span>
                </div>
                <InputNumber :max="10" :min="0" v-model="form.activity" />
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否北上取件</span>
                </div>
                <Checkbox
                  v-model="form.north_pick_up"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>地址顯示在APP(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.style_open"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否為加盟店(直營店不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.join"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否加入好物對換(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.is_shop"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否發送快件超時短訊通知？(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.is_outtime_sms"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span
                    >是否打折（範圍1-100百分比，0表示不打折,80表示打8折）</span
                  >
                </div>
                <InputNumber :max="100" :min="0" v-model="form.discount_bili" />
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>上傳門店圖片〖尺寸為800px*800px〗</span>
                  <br />
                  <br />
                  <span>「1.地圖，2.遠景，3.近景」</span>
                </div>

                <div
                  class="demo-upload-list"
                  v-for="item in defaultList"
                  :key="item.path + Math.random()"
                >
                  <template v-if="item.path != ''">
                    <img style="width: 100%; height: 100%" :src="item.path" />
                    <div class="demo-upload-list-cover">
                      <Icon
                        type="ios-eye-outline"
                        @click.native="handleView(item)"
                      ></Icon>
                      <Icon
                        type="ios-trash-outline"
                        @click.native="handleRemove_main(item)"
                      ></Icon>
                    </div>
                  </template>
                  <template v-else>
                    <Progress
                      v-if="item.showProgress"
                      :percent="item.percentage"
                      hide-info
                    ></Progress>
                  </template>
                </div>

                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="2048"
                  :on-success="handleSuccess"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  type="drag"
                  :action="uploadUrl + '/api/v1/test/update/s3/update'"
                  style="display: inline-block; width: 58px"
                >
                  <div style="line-height: 58px">
                    <Icon type="ios-camera" size="20"></Icon>
                  </div>
                </Upload>

                <Modal title="查閱圖片" v-model="visible" :footer-hide="true">
                  <img :src="imgName.path" v-if="visible" style="width: 100%" />
                </Modal>
              </FormItem>
            </Form>
          </Col>

          <Col span="11" push="1">
            <Form :label-width="300">
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>儲存數量</span>
                </div>
                <Input v-model="form.SaveQuantity"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>大格數量</span>
                </div>
                <Input v-model="form.large"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>中格數量</span>
                </div>
                <Input v-model="form.medium"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>小格數量</span>
                </div>
                <Input v-model="form.fine"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>智能櫃代號</span>
                </div>
                <Input
                  v-model="form.location_id"
                  placeholder="沒有請輸入 0"
                ></Input>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>聯絡電話(珠海倉庫)</span>
                </div>
                <span>{{ form.tel }}</span>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>營業結束時間</span>
                </div>
                <TimePicker
                  class="no-suffix"
                  type="time"
                  :clearable="false"
                  placeholder="結束日期"
                  v-model="form.end_time"
                  value-format="hh:mm:ss"
                  style="width: 100%"
                  :disabled="form.do_type === 2"
                ></TimePicker>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <!-- <em class="red">* </em> -->
                  <span>關聯專線</span>
                </div>
                <Select v-model="form.is_delivery" placeholder="請選擇關聯專線">
                  <Option :value="0">沒有</Option>
                  <Option
                    :value="item.id"
                    v-for="(item, index) in deliveryareaList"
                    :key="item.id"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>APP時間設置</span>
                </div>
                <Input v-model="form.time_description"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>超時費分賬(商家所得)%(積分+集金幣)</span>
                </div>
                <Input
                  v-model="form.outtime_fee"
                  type="number"
                  placeholder="沒有請輸入 0"
                ></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>積分分賬(商家所得)%</span>
                </div>
                <Input
                  v-model="form.intrgral_fee"
                  type="number"
                  placeholder="沒有請輸入 0"
                ></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>現金分賬(商家所得)%</span>
                </div>
                <Input
                  v-model="form.cash_fee"
                  type="number"
                  placeholder="沒有請輸入 0"
                ></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否24小時營業(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.do_type"
                  :true-value="2"
                  :false-value="1"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否設定送貨上門？(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.delivery"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否設定送貨上門支付方式？(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.delivery_default"
                  :true-value="1"
                  :false-value="null"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否參加抽獎？(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.is_lottery"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否發送上架短訊？(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.is_sms"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否拼多多包郵門店？(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.is_pdd"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否淘寶包郵門店？(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.is_taobao"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <!-- <FormItem>
                <div slot="label" class="form-label">
                  <span>是否開啓折扣</span>
                </div>
                <Checkbox
                  v-model="form.is_discount"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem> -->
            </Form>
          </Col>
        </Row>

        <div class="pg-btn-wrap" style="text-align: center">
          <div class="pg-btn style1" @click="handleCheckForm">確定</div>
          <div class="pg-btn" @click="handleBack">返回</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const uploadUrl = process.env.VUE_APP_API_URL;
export default {
  data() {
    return {
      pageParam: {},
      uploadList: [],
      defaultList: [],
      uploadFile: {
        file: "",
        base64: "",
      },
      form: {
        cainiao_match: "", //菜鳥碼
        ReceivingName: "", //網點名稱
        ReceivingNameShort: "", // 簡稱
        macauDistrict: "", // 澳門區
        ReceivingAddress: "", //網點地址
        Type: "", //自提點類型 1门店, 2智能柜
        X: "", //经度
        Y: "", //纬度
        SaveQuantity: "", //存储数量
        large: "", //大格數量
        medium: "", //中格数量
        fine: "", //小格数量
        location_id: "", //柜代号
        start_time: "",
        end_time: "",
        tel: "",
        admin_id: 0,
        do_type: "",
        style_open: "",
        activity: 0,
        offline_activity: 0,
        time_description: "",
        delivery: "",
        delivery_default: null,
        join: "",
        is_lottery: "",
        company_id: "",
        is_delivery: "",
        is_shop: "",
        is_sms: 0,
        is_pdd: 0,
        is_taobao: 0,
        is_outtime_sms: false,
        order_images: [],
        outtime_fee: 0,
        intrgral_fee: 0,
        cash_fee: 0,
        north_pick_up: 0,
        is_discount: 0,
        discount_bili: 0,
      },
      imgName: "",
      visible: false,
      isSubmiting: false,
      pickAdmin: [],
      samecityList: [],
      deliveryareaList: [],
      uploadUrl,
    };
  },
  mounted() {
    this.pageParam = this.$route.query;
    this.getDetail();
    this.getPickAdmin();
    this.getSamcityList();
    this.getDeliveryareaList();
    if (this.$store.state.logInfo.type == 2) {
      this.form.admin_id = this.$store.state.logInfo.user_id;
    }
  },
  methods: {
    handleRemove_main(file) {
      this.$Rq
        .requestAuth({
          url: this.$Api.shopDelImage,
          method: "post",
          data: {
            id: file.id,
          },
        })
        .then((res) => {
          this.$message.success(res.msg);
          if (res.code == 0) {
            const fileList = this.defaultList;
            this.defaultList.splice(fileList.indexOf(file), 1);
          }
        });
    },
    handleView(item) {
      // console.log(item.response.data.app_url + item.response.data.url);
      this.imgName = item;
      this.visible = true;
    },
    handleSuccess(res, file) {
      this.defaultList.push({
        path: res.data.path,
        pid: this.pageParam.id,
      });
      this.form.order_images = this.defaultList;
    },
    handleBeforeUpload(file) {
      const check =
        this.defaultList.filter((item) => item.type == "2").length < 5;
      if (!check) {
        this.$Utils.showTipInfo("最多可以上傳三張圖片。");
      }
      return check;
    },
    handleFormatError(file) {
      this.$Utils.showTipInfo(
        "文件格式不正確, 文件格式為" + file.name + "正確，請選擇jpg或png。"
      );
    },
    handleMaxSize(file) {
      this.$Utils.showTipInfo(
        "超過文件大小限制文件" + file.name + "太大了，不超過2M。"
      );
    },
    hanldeImgToBase64() {
      let file = this.uploadFile.file;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let _base64 = reader.result;
        this.uploadFile.base64 = _base64;
      };
      this.handleUploadImg();
    },
    handleUploadImg() {
      this.isSubmiting = true;
      let formData = new FormData();
      formData.append("file", this.uploadFile.file);
      this.$Rq
        .requestAuth({
          url: this.$Api.shopUploadImage,
          method: "post",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log(res);
          this.isSubmiting = false;
          if (res.code == 0) {
            this.form.avatar = res.data.app_url + res.data.url;
          } else {
            this.$Utils.showTipInfo(res.msg);
          }
        })
        .catch((err) => {
          this.isSubmiting = false;
        });
    },
    getDeliveryareaList() {
      this.$Rq
        .requestAuth({
          url: this.$Api.deliveryareaList,
          method: "get",
        })
        .then((res) => {
          if (res.code == 0) {
            this.deliveryareaList = res.data.data;
          }
        });
    },
    getPickAdmin() {
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAdmin,
          method: "post",
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAdmin = res.data.data;
          }
        });
    },
    getSamcityList() {
      this.$Rq
        .requestAuth({
          url: this.$Api.samecityUserList,
          method: "get",
        })
        .then((res) => {
          if (res.code == 0) {
            this.samecityList = res.data.data;
          }
        });
    },
    handleBack() {
      //返回
      this.$router.go(-1);
      // window.close();
    },
    getDetail() {
      //門店詳細
      this.isLoading = true;
      this.$Rq
        .requestAuth({
          url: this.$Api.shopDetail + "/" + this.pageParam.id,
          method: "get",
        })
        .then((res) => {
          this.isLoading = false;
          if (res.code == 0) {
            let resData = res.data;
            this.form = {
              cainiao_match: resData.cainiao_match,
              ReceivingName: resData.ReceivingName,
              ReceivingNameShort: resData.ReceivingNameShort,
              macauDistrict: resData.macauDistrict,
              ReceivingAddress: resData.ReceivingAddress,
              Type: resData.Type,
              X: resData.X,
              Y: resData.Y,
              SaveQuantity: resData.SaveQuantity,
              large: resData.large,
              medium: resData.medium,
              fine: resData.fine,
              location_id: resData.location_id,
              start_time: resData.start_time,
              end_time: resData.end_time,
              tel: resData.tel,
              admin_id: resData.admin_id,
              do_type: resData.do_type,
              style_open: resData.style_open,
              activity: parseInt(resData.activity),
              offline_activity: parseInt(resData.offline_activity),
              time_description: resData.time_description,
              delivery: resData.delivery,
              delivery_default: resData.delivery_default,
              join: resData.join,
              is_lottery: resData.is_lottery,
              is_sms: resData.is_sms,
              is_pdd: resData.is_pdd || 0,
              is_taobao: resData.is_taobao || 0,
              is_outtime_sms: resData.is_outtime_sms,
              company_id: resData.company_id,
              is_delivery: resData.is_delivery,
              is_shop: resData.is_shop,
              storeimg: resData.storeimg,
              outtime_fee: resData.outtime_fee,
              intrgral_fee: resData.intrgral_fee,
              cash_fee: resData.cash_fee,
              north_pick_up: resData.north_pick_up,
              is_discount: resData.is_discount,
              discount_bili: resData.discount_bili || 0,
            };
            this.defaultList = resData.storeimg;
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    handleCheckForm() {
      let form = this.form;
      if (form.cainiao_match === "") {
        this.$Utils.showTipInfo("請輸入門店序碼");
        return;
      } else if (form.ReceivingName === "") {
        this.$Utils.showTipInfo("請輸入網點名稱");
        return;
      } else if (form.ReceivingNameShort === "") {
        this.$Utils.showTipInfo("請輸入網點名稱（簡稱）");
        return;
      } else if (form.macauDistrict === "") {
        this.$Utils.showTipInfo("請選擇區域");
        return;
      } else if (form.ReceivingAddress === "") {
        this.$Utils.showTipInfo("請輸入網點地址");
        return;
      } else if (form.X === "") {
        this.$Utils.showTipInfo("請輸入經度");
        return;
      } else if (form.Y === "") {
        this.$Utils.showTipInfo("請輸入緯度");
        return;
      } else if (form.Type === "") {
        this.$Utils.showTipInfo("請選擇自提點類型");
        return;
      } else if (form.SaveQuantity === "") {
        this.$Utils.showTipInfo("請輸入儲存數量");
        return;
      } else if (form.large === "") {
        this.$Utils.showTipInfo("請輸入大格數量");
        return;
      } else if (form.medium === "") {
        this.$Utils.showTipInfo("請輸入中格數量");
        return;
      } else if (form.fine === "") {
        this.$Utils.showTipInfo("請輸入小格數量");
        return;
      } else if (form.location_id === "") {
        this.$Utils.showTipInfo("請輸入智能櫃代號");
        return;
      } else if (form.tel === "") {
        this.$Utils.showTipInfo("請輸入門店電話");
        return;
      } else if (form.time_description === "") {
        this.$Utils.showTipInfo("請輸入時間設置");
        return;
      } else if (form.company_id === "") {
        this.$Utils.showTipInfo("請輸入同城主號");
        return;
      }
      if (form.is_lottery === 1 && form.activity === 3) {
        this.$Utils.showTipInfo("注意: 參與抽獎不能和線上APP立減一齊選擇!");
        return;
      }
      this.handleSubmit();
    },
    handleSubmit() {
      let form = this.form;
      this.isSubmiting = true;

      this.$Rq
        .requestAuth({
          url: this.$Api.shopAdd + "/" + this.pageParam.id,
          method: "post",
          data: {
            cainiao_match: form.cainiao_match, //菜鳥碼
            ReceivingName: form.ReceivingName, //網點名稱
            ReceivingNameShort: form.ReceivingNameShort, //網點名稱簡稱
            macauDistrict: form.macauDistrict, //區域
            ReceivingAddress: form.ReceivingAddress, //網點地址
            Type: Number(form.Type), //自提點類型 1.門店, 2.智能櫃
            X: form.X, //經度
            Y: form.Y, //緯度
            SaveQuantity: Number(form.SaveQuantity), //存儲數量
            large: Number(form.large), //大格數量
            medium: Number(form.medium), //中格数量
            fine: Number(form.fine), //小格数量
            location_id: Number(form.location_id), //櫃代號
            start_time: form.start_time, //開始時間
            end_time: form.end_time, //結束時間
            tel: form.tel, //電話
            admin_id: form.admin_id, //管理員ID
            do_type: form.do_type, //自提點類型 1.門店, 2.智能櫃
            style_open: form.style_open, //地址顯示是否顯示在APP內？
            activity: form.activity, //線上立減3元
            offline_activity: form.offline_activity, //線下立減3元
            time_description: form.time_description, //時間設置
            delivery: form.delivery, //送貨上門
            delivery_default: form.delivery_default, //送貨上門設定
            join: form.join,
            is_lottery: form.is_lottery,
            company_id: form.company_id,
            is_delivery: form.is_delivery,
            is_shop: form.is_shop,
            is_outtime_sms: form.is_outtime_sms,
            is_sms: form.is_sms,
            is_pdd: form.is_pdd,
            is_taobao: form.is_taobao,
            images: form.order_images,
            outtime_fee: Number(form.outtime_fee),
            intrgral_fee: Number(form.intrgral_fee),
            cash_fee: Number(form.cash_fee),
            north_pick_up: form.north_pick_up,
            is_discount: form.is_discount,
            discount_bili: form.discount_bili,
          },
        })
        .then((res) => {
          this.isSubmiting = false;
          if (res.code == 0) {
            this.$Utils.showSuccess(res.msg);
          } else {
            this.$Utils.showTipInfo(res.msg);
          }
        })
        .catch((err) => {
          this.isSubmiting = false;
        });
    },
  },
};
</script>

<style>
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}

.demo-upload-list img {
  /*width: 100%;
  height: 100%;*/
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}

.w-e-toolbar {
  z-index: 2 !important;
}

.w-e-menu {
  z-index: 2 !important;
}

.w-e-text-container {
  z-index: 1 !important;
}
</style>

<style lang="scss" scoped>
@import "ShopManageEdit.scss";
</style>
